$shm_service_dashboard_head $mol_view
	title? \
	title_save? null
	title_keydown? null
	menu null $mol_view
	edit? null
	view? null
	view_visible true
	view_enabled false
	edit_color \
	view_color \
	sub /
		<= Title_edit $mol_string_button
			value? <=> title? \
			submit? <=> title_save? null
			event *
				^
				blur? <=> title_save? null
				keydown? <=> title_keydown? null
		<= menu
		<= Task_mode_controls $mol_view
			sub <= mode_rows /
				<= Task_mode_edit $mol_button_minor
					title \Редактирование
					click? <=> edit? null
					style *
						^
						color <= edit_color \
				<= Task_mode_view $mol_button_minor
					title \Просмотр
					enabled <= view_enabled false
					click? <=> view? null
					style *
						^
						color <= view_color \
